import * as React from 'react';

import { DataQualityDetailProps, DataQualityType, localizeDataQualityTypeName } from '@tableau/data-catalog-client-components';
import { DataQualityAssetType } from '@tableau/data-catalog-client-components/lib/src/dataQuality/DataQualityDetail';
import { SiteUrls } from '@tableau/shared-urls';
import { ListItem } from '@tableau/widgets';
import { L10n } from '../../ts/L10n/L10n';
import { dataQualityOwnerToTableauUser, IDataQualityIndicatorInfo } from '../../ts/models/IDataQualityIndicatorInfo';
import { DATA_QUALITY_DIALOG_TYPE_TEST_ID } from '../content/styles/DataQualityStyles';

export function dataQualityTypeListItem(type: DataQualityType): ListItem {
  return {
    content: <span>{localizeDataQualityTypeName(type)}</span>,
    value: dataQualityTypeToString(type),
    testId: DATA_QUALITY_DIALOG_TYPE_TEST_ID + '-' + dataQualityTypeToString(type).toLowerCase()
  };
}

export const dataQualityTypes: DataQualityType[] = [
  DataQualityType.WARNING,
  DataQualityType.DEPRECATED,
  DataQualityType.STALE,
  DataQualityType.MAINTENANCE
];

export function dataQualityTypeToString(type: DataQualityType): string {
  return DataQualityType[type];
}

export function stringToDataQualityType(type: string): DataQualityType {
  switch (type) {
    case DataQualityType[DataQualityType.WARNING]: return DataQualityType.WARNING;
    case DataQualityType[DataQualityType.DEPRECATED]: return DataQualityType.DEPRECATED;
    case DataQualityType[DataQualityType.STALE]: return DataQualityType.STALE;
    case DataQualityType[DataQualityType.MAINTENANCE]: return DataQualityType.MAINTENANCE;
  }
  return DataQualityType.WARNING;
}

export function dataQualityIndicatorInfoToProps(
  props: { assetUrl: string, assetName: string, assetType: DataQualityAssetType, onContentItem: boolean },
  urls: SiteUrls, info?: IDataQualityIndicatorInfo): DataQualityDetailProps | null {

  if (!info) {
    return null;
  }

  if (!info.isActive) {
    return null;
  }

  return {
    assetType: props.assetType,
    author: dataQualityOwnerToTableauUser(info.owner),
    localizedDate: L10n.localizedDateTime(info.updatedAt),
    type: stringToDataQualityType(info.type),
    message: info.message,
    newTab: false,
    isSevere: info.isSevere,
    ...props
  };
}
